module.exports = __webpack_public_path__ + "static/1-8101a29d5bb2f96daa3192d4c643fedf.jpg";